import { AgreementTeam } from './types';

// A team agreement is deactivated when it has been fully invoiced or its team was deactivated.
// Corrections cannot be made on it. Only shown on an active agreement: closing an agreement closes all its team
// agreements, so on a closed one it would mark every team.
export const isTeamAgreementInactive = (team: AgreementTeam, agreementIsActive: boolean): boolean =>
  agreementIsActive && !!team.team_agreement && !team.team_agreement.is_active;

export const teamNameWithAgreementStatus = (team: AgreementTeam, agreementIsActive: boolean): string =>
  isTeamAgreementInactive(team, agreementIsActive) ? `${team.name} (teamavtal inaktivt)` : team.name;
